import { FC } from "react";
import { Outlet } from "react-router-dom";
import Loader from "../components/UI/loader/Loader";
import { useAppSelector } from "../hooks/ReduxHooks";
import NotFoundPage from "../components/pages/not-found/NotFoundPage";
import { operatorRole } from "../redux/types/OperatorTypes";

const AdminRoutes: FC = () => {
  const { operator, authLoading, isAuthChecked } = useAppSelector(
    (state) => state.operator,
  );

  if (authLoading || !isAuthChecked) {
    return <Loader />;
  }

  const isDev = operator?.role === operatorRole.DEV;
  const isAdmin = operator?.role === operatorRole.ADMIN;

  if (isDev || isAdmin) {
    return <Outlet />;
  }

  return <NotFoundPage />;
};

export default AdminRoutes;
